import { heroEquipment } from "../HeroEquipment";

export const szkutnicy = {
  heroes: {
    "Mistrz szkutnik": {
      id: 0,
      startingEquipment: ["Sztylet", "Topór krasnoludów"],
      cost: 75,
      number: 1,
      equipmentList: heroEquipment["Szkutnicy z Barak Varr"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [3, 4, 4, 4, 4, 2, 3, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Dowódca",
        "Drużyna obsługi",
        "Inżynier",
        "Krzepki",
        "Mistrz inżynier",
        "Nieustępliwy",
        "Odporność na magię (2)",

        "Rankor",
        "Rewelator",
        "Saper",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
      ],
      exp: 20,
      skills: [0, 1, 2, 3, 5],
    },
    "Kowal run": {
      id: 1,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 50,
      number: 1,
      equipmentList: heroEquipment["Szkutnicy z Barak Varr"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [3, 4, 4, 3, 4, 1, 2, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Błogosławieństwo Valayi",
        "Kowal Run",
        "Krzepki",
        "Nieustępliwy",
        "Odporność na magię (2)",

        "Rankor",
        "Rozproszenie magii (1)",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
      ],
      exp: 12,
      skills: [0, 2, 3, 5],
    },
    "Mistrz inżynier": {
      id: 2,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 50,
      number: 1,
      equipmentList: heroEquipment["Szkutnicy z Barak Varr"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [3, 4, 4, 3, 4, 1, 2, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Drużyna obsługi",
        "Inżynier",
        "Krzepki",
        "Mistrz inżynier",
        "Nieustępliwy",
        "Odporność na magię (2)",

        "Rankor",
        "Saper",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
      ],
      exp: 12,
      skills: [0, 1, 2, 3, 5],
    },
    Zwiadowca: {
      id: 3,
      startingEquipment: ["Sztylet"],
      cost: 45,
      number: 2,
      equipmentList: heroEquipment["Szkutnicy z Barak Varr"].Zwiadowca,
      type: "Bohater",
      stats: {
        Początkowa: [3, 4, 4, 3, 4, 1, 2, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Krzepki",
        "Nieustępliwy",
        "Odporność na magię (2)",
        "Pułapkarz",
        "Ranger",
        "Rankor",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
        "Zwiadowca",
      ],
      exp: 8,
      skills: [0, 1, 4, 5],
    },
    "Wojownik klanowy": {
      id: 4,
      startingEquipment: ["Sztylet"],
      cost: 25,
      number: 12,
      equipmentList: heroEquipment["Szkutnicy z Barak Varr"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [3, 4, 3, 3, 4, 1, 2, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Chorążowie & sygnaliści",
        "Drużyna obsługi",
        "Krzepki",
        "Nieustępliwy",
        "Odporność na magię (2)",
        "Rankor",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
      ],
    },
    Bukanier: {
      id: 5,
      startingEquipment: ["Pistolet"],
      cost: 55,
      number: 5,
      equipmentList: heroEquipment["Szkutnicy z Barak Varr"].Bukanier,
      type: "Stronnik",
      stats: {
        Początkowa: [3, 4, 3, 3, 4, 1, 2, 1, 10],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Fanatyk",
        "Krzepki",
        "Nieustępliwy",
        "Ochronne tatuaże",
        "Odporność na magię (2)",
        "Pogromca",
        "Rajtar",
        "Rankor",
        "Trudny do zabicia",
        "Uporczywość",
        "Wodny",
        "Wspinaczka",
        "Zabobonny lęk",
      ],
    },
    Ogr: {
      id: 6,
      startingEquipment: ["Maczuga ogrów"],
      cost: 160,
      number: 1,
      equipmentList: heroEquipment["Gang przemytników"]["Ogr"],
      type: "Stronnik",
      stats: {
        Początkowa: [6, 3, 2, 4, 4, 3, 2, 2, 7],
        Maksymalna: [6, 6, 5, 5, 5, 5, 6, 5, 9],
      },
      rules: [
        "Bycza szarża",
        "Duży cel",
        "Głód trzewi",
        "Oznakowany gnoblar (gnoblar-uwaga)",
        "Przepastne trzewia",
        "Strach",
        "Tempy",
        "Wielkolud",
      ],
    },
    "Ptasznik z Barak Varr": {
      id: 7,
      startingEquipment: ["Sztylet", "Broń wielka", "Mechaniczne skrzydła"],
      cost: 55,
      number: 3,
      equipmentList: heroEquipment["Szkutnicy z Barak Varr"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [3, 4, 3, 3, 4, 1, 2, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Krzepki",
        "Lot",
        "Nieustępliwy",
        "Odporność na magię (2)",
        "Ptasznik",
        "Rankor",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
        "Zasadzka",
        "Zwiadowca",
      ],
    },
    "Balon bojowy": {
      id: 8,
      startingEquipment: [],
      cost: 150,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Początkowa: [2, "-", "-", 4, 5, 5, "-", "-", "-"],
        Maksymalna: [2, "-", "-", 4, 5, 5, "-", "-", "-"],
      },
      rules: [
        "Bombardowanie",
        "Duży cel",
        "Lot",
        "Łatwopalny",
        "Machina wojenna",
        "Stanowisko strzeleckie",
        "Trafienie z uderzenia",
        "Uporczywość",
        "Zawis",
        "Zwiadowca",
      ],
    },
    Żyrokopter: {
      id: 9,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Początkowa: [2, "-", "-", 4, 5, 5, "-", "-", "-"],
        Maksymalna: [2, "-", "-", 4, 5, 5, "-", "-", "-"],
      },
      rules: [
        "Bombardowanie (płonący atak)",
        "Duży cel",
        "Kusza parowa",
        "Lot",
        "Machina wojenna",
        "Trafienie z uderzenia",
        "Uporczywość",
        "Zawis",
        "Zwiadowca",
      ],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 12,
  name: "Szkutnicy z Barak Varr",
  nature: "Neutralna",
  armyRules: ["Kontakty handlowe (3)", "Rozrzutność", "Zhańbiony"],
  mercenaries: [
    "Goniec",
    "Miotacz ołowiu",
    "Ochroniarz",
    "Ogniomistrz",
    "Poszukiwacz złota",
    "Strażnik dróg",
    "Zwiadowca",
  ],
};
